'use client';

import Link from 'next/link';
import { trackHeroAction } from '../../lib/analytics';

export default function ConsultingButtons() {
    return (
        <div className="btn-group">
            <a
                href="mailto:info@tomaili.com"
                className="btn btn-primary"
                onClick={() => trackHeroAction('consulting_email')}
            >
                İletişime Geç
            </a>
            <Link
                href="/"
                className="btn btn-secondary"
                onClick={() => trackHeroAction('consulting_portfolio')}
            >
                Portfolyomu Gör
            </Link>
        </div>
    );
}
